export function redirectToExternalUrl(target: string): boolean {
  const normalizedTarget = target.trim();

  if (!normalizedTarget || typeof window === "undefined") {
    return false;
  }

  window.location.replace(normalizedTarget);

  // Some in-app browsers ignore the first replace call; retry once shortly after.
  window.setTimeout(() => {
    window.location.href = normalizedTarget;
  }, 180);

  return true;
}
